import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRewardType, updateRewardType } from '../../slices/TransactionHistorySlice/RewardTypeSlice';
import Pagination from '../../components/Pagination';
import EditableTable from '../../components/EditableTable';
import Modal from '../../components/Modal';
import ChangeLog from '../../components/ChangeLog'; 
import Loader from "../../components/Loader";
import AddRewardType from './AddRewardType';
// import AddQuery from "./AddQuery"


const RewardType = () => {
  const dispatch = useDispatch();
  const { rewardTypeList , status, error } = useSelector((state) => state.rewardType);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null); // Track which row is in edit mode
  const [editedData, setEditedData] = useState({}); // Store temporary data for edited row

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(rewardTypeList.result) ? rewardTypeList.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(rewardTypeList.result) ? Math.ceil(rewardTypeList.result?.length / itemsPerPage) : 0;
  const editableFields = ['is_read', 'body', 'title', 'status' ];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [addModalDis, setAddModalDis] = useState(false);

  useEffect(() => {
    if(status==='idle'){
      dispatch(fetchRewardType());
    }
  }, [dispatch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = rewardTypeList.result?.find((user) => user.id === rowId);
    setEditedData(rowData); // Pre-fill the fields with current row data
  };

  const handleSave = async () => {
    // Extract only id, point, and detail for the API call
    const { id, title, status } = editedData;
    const updatedData = {id,title,status};
    await dispatch(updateRewardType(updatedData));
    dispatch(fetchRewardType());
    setEditRowId(null); // Exit edit mode after saving
  };

  const handleCancel = () => {
    setEditRowId(null); // Exit edit mode and reset data
    setEditedData({}); // Reset to original data
  };

  const handleLog = (id)=>{
    const logData = rewardTypeList?.Change_Log?.filter((f)=> f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  const handleChange = (e, field,val) => {
    if(field==="active" || field==="status" || field==='is_read'){
      setEditedData((prev) => ({
        ...prev,
        [field]:!val,
      }));
    }else{
      setEditedData((prev) => ({
        ...prev,
        [field]:e.target.value,
      }));
    }
};



  const headers = rewardTypeList.result?.length > 0 ? Object.keys(rewardTypeList.result[0]).filter((key) => key !== 'id') : [];

  if (status === 'loading') {
    return <Loader />
  }

  // if (status === 'failed') {
  //   return <div>Error: {error}</div>;
  // }

  if (!rewardTypeList || rewardTypeList.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <div className="w-full flex items-center flex-col">
      <div className="max-w-[93%] overflow-scroll">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable field
        // hideChangeLog={true}
      />
      </div>
    


  <div className="flex mt-4 items-center justify-between w-11/12">

<Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>

<button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={()=>setAddModalDis(true)}> Add Reward Type </button>

</div>

<Modal
        isOpen={addModalDis}
        onClose={()=>setAddModalDis(false)}
        title="Add Reward Type"
        content={<AddRewardType/>}
/> 

<Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
  );
};

export default RewardType;
